

function Affiliates(props) {
  return 'Affiliates'
}
export default Affiliates;